<template>
  <div>
    <h6>* Deze data is samengesteld uit Salesforcedata</h6>
    <hr>
    <div v-for="data in keyData">
      <p><strong>{{data.key}}</strong><br>
        {{data.data}}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'project-key-data',
  props: ['keyData'],
}
</script>
